import { render, staticRenderFns } from "./SuccessBox.vue?vue&type=template&id=64cb2697&scoped=true"
import script from "./SuccessBox.vue?vue&type=script&lang=js"
export * from "./SuccessBox.vue?vue&type=script&lang=js"
import style0 from "./SuccessBox.vue?vue&type=style&index=0&id=64cb2697&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cb2697",
  null
  
)

export default component.exports